import { Card } from 'antd';
import { CardProps } from 'antd/lib/card';

interface Props extends CardProps {}

export default function EnhancedCard(props: Props) {
    return <Card {...props} />;
}
